import { IconType } from "../icon-props";

const Upload: IconType = (
        <>
            <path fillRule="evenodd" clipRule="evenodd" d="M7.05319 9.778L11.0032 5.828V15.5L13.0032 15.5V5.828L16.9532 9.778L18.3672 8.364L12.0032 2L5.63919 8.364L7.05319 9.778ZM20 19H4V12H2V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V12H20V19Z"/>
        </>
    );

export default Upload;